"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var dedupe_1 = require("./dedupe");
exports.Dedupe = dedupe_1.Dedupe;
var functiontostring_1 = require("./functiontostring");
exports.FunctionToString = functiontostring_1.FunctionToString;
var sdkinformation_1 = require("./sdkinformation");
exports.SDKInformation = sdkinformation_1.SDKInformation;
var inboundfilters_1 = require("./inboundfilters");
exports.InboundFilters = inboundfilters_1.InboundFilters;
var extraerrordata_1 = require("./extraerrordata");
exports.ExtraErrorData = extraerrordata_1.ExtraErrorData;
var debug_1 = require("./pluggable/debug");
exports.Debug = debug_1.Debug;
var rewriteframes_1 = require("./pluggable/rewriteframes");
exports.RewriteFrames = rewriteframes_1.RewriteFrames;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sentry/core/dist/integrations/index.js
// module id = 204
// module chunks = 2